import { Token } from '@pancakeswap/sdk'
import { ChainId } from '@pancakeswap/chains'

interface WarningTokenList {
  [chainId: number]: {
    [key: string]: Token
  }
}

const SwapWarningTokens = <WarningTokenList>{
}

export default SwapWarningTokens
